export enum CoachSmartSpaceChecklistSteps {
  SMART_SPACE_CHECK = 1,
  ADDITIONAL_STANDARDS = 2,
  SAFETY_STRUCTURE_AREA = 3,
}
